import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Apps.css';

// Importar imágenes de aplicaciones
import sportsApp from '../assets/sports.webp';
import fleetApp from '../assets/fleet.webp';
import contractsApp from '../assets/contratos.webp';

const AppCard = ({ title, description, image }) => (
  <div className="app-card">
    <div className="image-container">
      <div className="redacted-overlay">REDACTED</div>
      <img src={image} alt={title} className="app-image" />
    </div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const Apps = () => {
    const { t } = useTranslation();

    return (
        <section id="aplicaciones" className="apps-section">
            <div className="apps-container">
                <div className="apps-title-container">
                    <h2>{t('apps.title')}</h2>
                    <span className="soon-stamp">SOON™</span>
                </div>
                <p>{t('apps.description')}</p>
                <div className="applications-grid">
                    <AppCard title={t('apps.sports.title')} description={t('apps.sports.description')} image={sportsApp} />
                    <AppCard title={t('apps.fleet.title')} description={t('apps.fleet.description')} image={fleetApp} />
                    <AppCard title={t('apps.contracts.title')} description={t('apps.contracts.description')} image={contractsApp} />
                </div>
            </div>
        </section>
    );
};

export default Apps; 